import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import styled from "styled-components";
import logo from "../../assets/images/vm-logo.svg";

const LogoWrapper = styled.div`
  color: ${({ theme: { colors } }) => colors.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  padding: 10px;
  cursor: pointer;
`;

const StyledImg = styled.img`
  cursor: pointer;
  max-height: 60px;
`;

const Logo = ({ inApp }) => {
  const history = useHistory();
  const route = inApp ? "/app/dictionary" : "/";

  return (
    <LogoWrapper onClick={() => history.push(route)}>
      <StyledImg src={logo} alt="VerbumMemo logo" />
    </LogoWrapper>
  );
};

Logo.propTypes = {
  inApp: PropTypes.bool,
};

Logo.defaultProps = {
  inApp: false,
};

export default Logo;
